(() => {
  function initHeader(root = document) {
    root.querySelectorAll("[data-site-header]").forEach((header) => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = "true";
      const button = header.querySelector("[data-menu-button]");
      const menu = header.querySelector("[data-mobile-menu]");
      if (!button || !menu) return;

      function setOpen(open) {
        button.setAttribute("aria-expanded", String(open));
        menu.hidden = !open;
        document.body.classList.toggle("menu-open", open);
      }
      button.addEventListener("click", () => setOpen(button.getAttribute("aria-expanded") !== "true"));
      menu.addEventListener("click", (event) => {
        if (event.target.closest("a")) setOpen(false);
      });
      window.addEventListener("resize", () => {
        if (window.innerWidth > 990) setOpen(false);
      });
    });
  }

  function initFeatureRails(root = document) {
    root.querySelectorAll("[data-feature-rail]").forEach((rail) => {
      if (rail.dataset.paginationInitialized) return;
      const section = rail.closest(".feature-section");
      const pagination = section?.querySelector("[data-feature-pagination]");
      const panels = Array.from(rail.querySelectorAll(".feature-panel"));
      const dots = Array.from(pagination?.querySelectorAll("[data-feature-dot]") || []);
      if (!pagination || !panels.length || panels.length !== dots.length) return;

      rail.dataset.paginationInitialized = "true";
      let frame;

      function setActive(index) {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-current", String(active));
        });
      }

      function updateActiveDot() {
        frame = undefined;
        const railCenter = rail.getBoundingClientRect().left + rail.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        panels.forEach((panel, index) => {
          const rect = panel.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - railCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        setActive(closestIndex);
      }

      rail.addEventListener("scroll", () => {
        if (!frame) frame = requestAnimationFrame(updateActiveDot);
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          panels[index].scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "nearest",
            inline: "center"
          });
          setActive(index);
        });
      });

      window.addEventListener("resize", updateActiveDot);
      updateActiveDot();
    });
  }

  function initCartIntake(root = document) {
    root.querySelectorAll("[data-cart-intake-form]").forEach((form) => {
      if (form.dataset.intakeInitialized) return;
      form.dataset.intakeInitialized = "true";

      const vin = form.querySelector("[data-cart-vin]");
      const contact = form.querySelector("[data-cart-contact]");
      const notes = form.querySelector("[data-cart-notes]");
      const checkoutButton = form.querySelector("[data-cart-secure-checkout]");
      const status = form.querySelector("[data-cart-intake-status]");
      if (!vin || !contact || !notes || !checkoutButton || !status) return;

      function showError(message) {
        status.hidden = false;
        status.textContent = message;
        status.classList.add("is-error");
      }

      form.addEventListener("submit", async (event) => {
        if (event.submitter?.name !== "checkout") return;
        event.preventDefault();

        vin.value = vin.value.replace(/\s+/g, "").toUpperCase();
        if (!form.reportValidity()) return;

        checkoutButton.disabled = true;
        checkoutButton.textContent = "Saving vehicle details…";
        status.hidden = true;
        status.classList.remove("is-error");

        const rootPath = window.Shopify?.routes?.root || "/";
        const intake = {
          vin: vin.value,
          contact: contact.value,
          notes: notes.value.trim() || "None provided",
        };

        try {
          const cartResponse = await fetch(`${rootPath}cart.js`, { headers: { Accept: "application/json" } });
          if (!cartResponse.ok) throw new Error("Shopify could not read the cart.");
          const cart = await cartResponse.json();
          const serviceItem = cart.items.find((item) => item.properties?.Vehicle);
          if (!serviceItem) throw new Error("The Matrix service item could not be identified in the cart.");

          const properties = {
            ...serviceItem.properties,
            "VIN": intake.vin,
            "Preferred contact method": intake.contact,
            "Additional notes": intake.notes,
          };
          const lineResponse = await fetch(`${rootPath}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: serviceItem.key, quantity: serviceItem.quantity, properties }),
          });
          if (!lineResponse.ok) throw new Error("Shopify could not attach the VIN to the service item.");

          const attributeResponse = await fetch(`${rootPath}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              attributes: {
                "Vehicle intake – VIN": intake.vin,
                "Vehicle intake – Preferred contact": intake.contact,
                "Vehicle intake – Notes": intake.notes,
              },
            }),
          });
          if (!attributeResponse.ok) throw new Error("Shopify could not save the checkout details.");

          window.location.assign(`${rootPath}checkout`);
        } catch (error) {
          checkoutButton.disabled = false;
          checkoutButton.textContent = "Continue to secure checkout";
          showError(error.message || "The vehicle details could not be saved. Please try again.");
        }
      });
    });
  }

  function init(root = document) {
    initHeader(root);
    initFeatureRails(root);
    initCartIntake(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init());
  else init();
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
